import { render, staticRenderFns } from "./LadingPage.vue?vue&type=template&id=4b5fd33d&scoped=true"
import script from "./LadingPage.vue?vue&type=script&lang=js"
export * from "./LadingPage.vue?vue&type=script&lang=js"
import style0 from "./LadingPage.vue?vue&type=style&index=0&id=4b5fd33d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5fd33d",
  null
  
)

export default component.exports